import gql from 'graphql-tag';

export const GENERATE_COINFIRM_ENHANCED_REPORT = gql`
  mutation generateCoinfirmEnhancedReport($input: GenerateCoinfirmEnhancedReportInput!) {
    generateCoinfirmEnhancedReport(input: $input)
  }
`;
